// OogwaiProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import React from "react";
import { useGetGeneralSettingsQuery } from "../services/settingsSlice";

const OogwaiProtectedRoute = ({ children }:any) => {
  const { data: userData } = useGetGeneralSettingsQuery("", {
    refetchOnMountOrArgChange: true,
  });

  const getUserData = userData?.settings;
  
  const getEmail = localStorage.getItem("oogw.ai_user_email") || getUserData?.email;

  const oogwaiUser =
    getEmail &&
    getEmail !== "info@oogw.ai" &&
    getEmail !== "demo@oogw.ai"
      ? getEmail.split("@")[1]?.includes("oogw.ai")
      : false;

  // ❌ Not oogwaiUser → redirect
  if (!oogwaiUser) {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ Allowed
  return children;
};

export default OogwaiProtectedRoute;
